import { Button } from "@itandi/itandi-bb-ui";
import type React from "react";

export const renderSearchButton = (
	handleDetailSearch: () => Promise<void>
): React.ReactElement => (
	<Button onClick={handleDetailSearch} variant="primary">
		検索
	</Button>
);
